import React from 'react';
import { Card, Flex, Typography, theme } from 'antd';
import { ExpandOutlined, FileDoneOutlined, ReconciliationOutlined } from '@ant-design/icons';

import { AiCrawlerLineup, useAiCrawlerLineup } from '../../shared';

function configurationChecksDescription(lineup: AiCrawlerLineup): string {
  const bots = Array.from(lineup.providerToDiagnosticsCrawler.values());
  const simulatedBots = `${bots.slice(0, -1).join(', ')}, and ${bots[bots.length - 1]}`;
  return (
    'Diagnostics verifies AI crawlers are not blocked in your Prerender integration, robots.txt, CDN, and firewall configuration. ' +
    `We check access by simulating requests from these four bots: ${simulatedBots}. ` +
    'Other bots, such as user-triggered fetchers like ChatGPT-User and search crawlers like OAI-SearchBot, may have different access and should be checked separately.'
  );
}

function diagnosisSteps(lineup: AiCrawlerLineup) {
  return [
    {
      icon: <ExpandOutlined />,
      title: 'Automatic scan',
      description: 'Runs automatically for the selected domain and typically finishes within 1–2 minutes.',
    },
    {
      icon: <FileDoneOutlined />,
      title: 'Configuration checks',
      description: configurationChecksDescription(lineup),
    },
    {
      icon: <ReconciliationOutlined />,
      title: 'Results & notifications',
      // TODO: add back notification email part once email delivery is confirmed
      description: 'The report appears in the table below.',
    },
  ];
}

export default function HowWeDiagnoseCard() {
  const { token } = theme.useToken();
  const steps = diagnosisSteps(useAiCrawlerLineup());

  return (
    <div>
      <Typography.Title level={4} style={{ marginBottom: token.marginXS }}>
        How we diagnose your site
      </Typography.Title>
      <Card styles={{ body: { padding: token.paddingMD } }}>
        <div
          style={{
            background: `${token.colorPrimaryBg}4D`,
            borderRadius: token.borderRadiusLG,
            padding: token.paddingLG,
          }}
        >
          <Flex vertical gap={token.marginLG}>
            {steps.map((step) => (
              <Flex key={step.title} gap={token.margin} align="flex-start">
                <div
                  style={{
                    width: token.sizeXL,
                    height: token.sizeXL,
                    borderRadius: '50%',
                    background: token.colorFillContent,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: token.fontSizeSM,
                    color: token.colorPrimary,
                    flexShrink: 0,
                  }}
                >
                  {step.icon}
                </div>
                <Flex vertical>
                  <Typography.Text style={{ fontSize: token.fontSizeLG, lineHeight: token.lineHeightLG }}>
                    {step.title}
                  </Typography.Text>
                  <Typography.Text type="secondary" style={{ fontSize: token.fontSize }}>
                    {step.description}
                  </Typography.Text>
                </Flex>
              </Flex>
            ))}
          </Flex>
        </div>
      </Card>
    </div>
  );
}
